// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class ProvidersPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicProviders';
        this.Server = this.props.context.getState().server.publicProviders;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'phoneNumber', 'emailAddress'];
        // this.exportButton = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'name',
                    label: 'name',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'phoneNumber',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Phone',
                    displayGrid: true
                },
                {
                    id: 'emailAddress',
                    label: 'email',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'region',
                    label: 'region',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'gateways',
                    label: 'gateways',
                    alignRight: false,
                    cell: 'ContextMultiSelect',
                    type: 'array',
                    array: 'gateways',
                    display: 'name',
                    primary: 'name',
                    from: 'publicGateways',
                    displayGrid: true,
                },
                {
                    id: 'registrationNumber',
                    label: 'registrationNumber',
                    alignRight: false,
                    cell: 'Number',
                    displayGrid: true,
                },
                {
                    id: 'website',
                    label: 'website',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
